import React from 'react';
import Card from './Card.js';

class Wheel extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            radius: 220,
            cards: [],
            theta: 0.0,
            curentCabin:3
        }
        this.innerRotate = Math.PI*2/7;
        this.temp_theta = 20.0;
        this.anim_id = null;
    }

    componentDidMount() {
        let center_of_wheel = {
            x: parseFloat(this.wheel.style.width) / 2,
            y: parseFloat(this.wheel.style.height) / 2
        }
        let temp_cards = [];

        for (let i = 1; i < 8; i++) {
            temp_cards.push(
                <Card data={i} classname={`cabin${i}`} getInnerRotate={this.getInnerRotate} radius={this.state.radius} radian_interval={(Math.PI * 2 / 7) * i} center={center_of_wheel} key={`cabin_${i}`} >{i}</Card>
            );
        }

        this.setState({ cards: temp_cards });
    }

    getInnerRotate=()=>{
        return this.innerRotate;
    }

    handle_scroll = event => {
        if(this.state.curentCabin === 7){
            this.setState({curentCabin: 1})
        }else {
            const newCabin = this.state.curentCabin+1;
            this.setState({curentCabin: newCabin})
        }
        this.props.updateCurrentCabin(this.state.curentCabin);
    
        clearTimeout(this.anim_id);
        const rotateAmount = 360/7;
        this.wheel.style.transform = `translate(-50%, -50%) rotate(${this.temp_theta + rotateAmount}deg)`;
        this.temp_theta += rotateAmount;

        this.anim_id = setTimeout(() => {
            this.setState({ theta: this.temp_theta });
            let center_of_wheel = {
                x: parseFloat(this.wheel.style.width) / 2,
                y: parseFloat(this.wheel.style.height) / 2
            }
            let temp_cards = [];
    
            for (let i = 1; i < 8; i++) {
                temp_cards.push(
                    <Card data={i} classname={`cabin${i}`}  getInnerRotate={this.getInnerRotate} radius={this.state.radius} radian_interval={(Math.PI *2/ 7) * i} center={center_of_wheel} key={`cabin_${i}`} >{i}</Card>
                );
            }
            this.setState({ cards: temp_cards });
        }, 1500);
        
    }

    render() {
        return (
            <div onClick={this.handle_scroll} ref={ref_id => this.wheel = ref_id} style={styles.wheel}>
                {this.state.cards}
            </div>
        )

    }
}

const styles = {
    wheel: {
        margin: '0',
        padding: '0',
        position: 'absolute',
        top: '235px',
        left: '230px',
        transform: 'translate(-50%, -50%) rotate(27deg)',
        height: '100px',
        width: '100px',
        backgroundSize:'cover',
        transitionDuration: `1s`
    }
}

export default Wheel;